import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const containerVariants = cva('w-full rounded-lg', {
  variants: {
    variant: {
      task: 'bg-white/10',
      confirm: 'bg-[#2F3036] backdrop-blur-3xl !rounded-2xl',
      'blur-10': 'bg-white/10 backdrop-blur-3xl !rounded-[80px]',
      'blur-20': 'bg-white/20 backdrop-blur-3xl !rounded-[80px]',
      'task-blur': css.taskBlur,
      'circle-button': css.circleButton,
      'black-60': 'bg-black/60 backdrop-blur-3xl',
      notification:
        'bg-white/40 backdrop-blur-[32px] !rounded-[80px] drop-shadow-[0_8px_24px_rgba(0,0,0,0.4)]',
      indicator:
        'bg-main-bg !rounded-[80px] h-6 drop-shadow-[0_-1px_0px_rgba(255,255,255,0.4)]',
    },
    padding: {
      '10-12': 'py-2.5 px-3',
      '16': 'p-4',
      '8': 'p-2',
      '4-8': 'py-1 px-2',
      '12': 'p-3',
    },
  },
});

interface ContainerProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof containerVariants>,
    PropsWithChildren {}

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ variant, padding, children, ...props }, ref) => (
    <div
      ref={ref}
      {...props}
      className={cn(containerVariants({ variant, padding }), props.className)}
    >
      {children}
    </div>
  ),
);

export { Container };
